import { render, staticRenderFns } from "./CrossBorder.vue?vue&type=template&id=2b0dbc62&scoped=true&"
var script = {}
import style0 from "./CrossBorder.vue?vue&type=style&index=0&id=2b0dbc62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0dbc62",
  null
  
)

export default component.exports